<div class="dropdown-candy-box">
    <button #candyBox class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
        aria-label="Aplicaciones y servicios GOV.CO" aria-describedby="tooltip-candy-box">
        <span class="icon-th"></span>
    </button>
    <div class="tooltip-text-container" role="tooltip">
        <div class="dropdown-arrow"></div>
        <span class="text-2 d-block" id="tooltip-candy-box" lang="es">
            Acceda a Carpeta Ciudadana Digital y demás servicios relacionados con el Portal Único del Estado
            Colombiano.
        </span>
    </div>
    <div id="menu-candy-box" class="dropdown-menu dropdown-menu-candy-box" aria-labelledby="dropdown-title-id"
        role="region" tabindex="-1">
        <div class="dropdown-arrow"></div>
        <h6 id="dropdown-title-id">
            Aplicaciones y servicios GOV.CO
        </h6>
        <ul>
            <li>
                <a class="dropdown-item" rel="noopener" href="{{urls.home}}" target="_blank">
                    <div class="dropdown-item-icon icon-govco"></div>
                    <span class="caption d-block">Portal GOV.CO</span>
                </a>
            </li>
            <li>
                <a class="dropdown-item" rel="noopener" href="{{urls.carpetaciudadana}}" target="_blank">
                    <div class="dropdown-item-icon icon-folder-user"></div>
                    <span class="caption d-block">Carpeta Ciudadana</span>
                </a>
            </li>
            <li>
                <a class="dropdown-item" rel="noopener" href="{{urls.tramites}}" target="_blank">
                    <div class="dropdown-item-icon icon-ciiu"></div>
                    <span class="caption d-block">Consulta CIIU</span>
                </a>
            </li>
        </ul>
    </div>
</div>